import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { getEmbedUrlForId } from './youtube';
export function YoutubeIframe(_a) {
    var youtubeId = _a.youtubeId;
    var _b = useState(false), iframeLoaded = _b[0], setIframeLoaded = _b[1];
    var handleLoadIframe = function () {
        setIframeLoaded(true);
    };
    var origin = typeof window === 'undefined' ? '' : window.location.origin;
    return (_jsx("div", { className: "faq-answer-youtube", children: _jsx("iframe", { className: iframeLoaded ? '' : 'hidden', onLoad: handleLoadIframe, src: getEmbedUrlForId(youtubeId, { rel: '0', origin: origin }), title: "YouTube video player", allow: "fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" }) }));
}
//# sourceMappingURL=YoutubeIframe.js.map